var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-collapse',{class:['accordion-content', { 'is-modest': _vm.modest }],attrs:{"id":_vm.id,"accordion":_vm.group,"visible":_vm.visible,"role":"tabpanel"}},[_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }